module.exports = __webpack_public_path__ + "img/20210906-1630911044830200.797bdd12.jpg";